export default __webpack_public_path__ + "static/media/ENTP.de9305cf.svg";